import { Flex, Image } from '@chakra-ui/react';

import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

const EmptyScreen = ({
  heading = '',
  description = '',
  illustrationSrc,
  illustrationStyle = {},
  CTAComp = null,
  CTAContainerStyle = {},
  descriptionComp = null,
  headerComp = null,
  isSmallTextSize = false,
  smallTextMargin = '16px',
}) => {
  const TextHeadingComp = isSmallTextSize ? TextBodyMedium : TextHeader3;
  const TextDescriptionComp = isSmallTextSize ? TextBodyMedium : TextBodyMedium;
  return (
    <Flex flexDir="column" p={isSmallTextSize ? '8px' : '20px'} alignItems="center">
      {illustrationSrc && (
        <Image src={illustrationSrc} maxH="160px" alt="Empty Screen" style={{ ...illustrationStyle }} />
      )}
      <Flex flexDir="column" alignItems="center">
        {headerComp ? (
          headerComp()
        ) : (
          <TextHeadingComp textAlign="center" bold mt={isSmallTextSize ? smallTextMargin : '16px'}>
            {heading}
          </TextHeadingComp>
        )}

        {descriptionComp ? (
          descriptionComp()
        ) : (
          <TextDescriptionComp maxW="740px" textAlign="center" color="text.g2" mt={1}>
            {description}
          </TextDescriptionComp>
        )}
        {CTAComp && <div style={{ marginTop: '24px', ...CTAContainerStyle }}>{CTAComp()}</div>}
      </Flex>
    </Flex>
  );
};

export { EmptyScreen };
